import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import RepaymentOpExpensesModalUI from './RepaymentOpExpensesModalUI.js'

class RepaymentOpExpensesModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: null,
      opExpenseDate: this.props.selectedRepayment ? this.props.selectedRepayment.opExpenseDateISO : '',
      opExpenseDateError: null,
      opExpense: this.props.selectedRepayment ? this.props.selectedRepayment.opExpenseF5 : '',
      opExpenseError: null,
      opExpenseRemarks: this.props.selectedRepayment ? this.props.selectedRepayment.opExpenseRemarks : '',
      opExpenseRemarksError: null
    }
  }

  render() {
    return (
      <RepaymentOpExpensesModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        status={this.state.status}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        opExpenseDate={this.state.opExpenseDate}
        onOpExpenseDateChange={(selectedDateISO) => { this.setState({ opExpenseDate: selectedDateISO }) }}
        opExpenseDateError={this.state.opExpenseDateError}
        setOpExpenseDateError={(error) => { this.setState({ opExpenseDateError: error }) }}
        //
        opExpense={this.state.opExpense}
        onOpExpenseChange={(event) => { this.setState({ opExpense: event.target.value }) }}
        opExpenseError={this.state.opExpenseError}
        setOpExpenseError={(error) => { this.setState({ opExpenseError: error }) }}
        //
        opExpenseRemarks={this.state.opExpenseRemarks}
        onOpExpenseRemarksChange={(event) => { this.setState({ opExpenseRemarks: event.target.value }) }}
        opExpenseRemarksError={this.state.opExpenseRemarksError}
        setOpExpenseRemarksError={(error) => { this.setState({ opExpenseRemarksError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let repayment = this.props.selectedRepayment
    if (!repayment || prevProps.selectedRepayment && prevProps.selectedRepayment.scheduledDate === repayment.scheduledDate)
      return
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${this.props.selectedRepayment.scheduledDate}/oopExpenses`,
      this.onSubmitCallback, {
      oopExpenseDateISO: this.state.opExpenseDate,
      oopExpenseF: this.state.opExpense,
      oopExpenseRemarks: this.state.opExpenseRemarks
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 100)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default RepaymentOpExpensesModalSF
